import { configQuery, SessionChange, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { notificationService, NotificationDelay } from '@gig/magic-messaging';

/**
 */
var RgLimitsPrompterComponent = /** @class */ (function (_super) {
    __extends(RgLimitsPrompterComponent, _super);
    function RgLimitsPrompterComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The interval of time in seconds between the rg notification
         */
        _this.interval = null;
        /**
         * The countries where the rg notification is showing up
         */
        _this.enabledCountries = [];
        _this.notificationTimeout = null;
        _this.returning = true;
        return _this;
    }
    RgLimitsPrompterComponent.prototype.created = function () {
        var _this = this;
        configQuery('limits.rgLimitsNotificationInterval', function (interval) {
            _this.interval = interval !== null && interval !== void 0 ? interval : null;
        });
        configQuery('limits.rgLimitsNotificationEnabledCountries', function (enabledCountries) {
            _this.enabledCountries = enabledCountries !== null && enabledCountries !== void 0 ? enabledCountries : [];
        });
    };
    RgLimitsPrompterComponent.prototype.render = function () {
        return null;
    };
    RgLimitsPrompterComponent.prototype.sessionChange = function (isLoggedIn) {
        if (!isLoggedIn) {
            this.returning = false;
            this.end();
            return;
        }
        var user = magic.session.getUser();
        if (!this.enabledCountries.includes(user.country)) {
            return;
        }
        if (!this.returning) {
            this.showNotification();
        }
        this.start();
    };
    /**
     * - Checks if the user country is enabled
     * - Calculate the time to show the notification using the user last visit
     * so that if multiple tabs are open the notifications are shown at the same time
     */
    RgLimitsPrompterComponent.prototype.start = function () {
        if (this.notificationTimeout) {
            return;
        }
        var user = magic.session.getUser();
        if (!user) {
            return;
        }
        var lastVisit = new Date(user.lastVisit);
        var secondsSince = (new Date().getTime() - lastVisit.getTime()) / 1000;
        var firstTimeout = (this.interval - (secondsSince % this.interval)) * 1000;
        this.startInterval(firstTimeout);
    };
    RgLimitsPrompterComponent.prototype.end = function () {
        if (this.notificationTimeout) {
            clearTimeout(this.notificationTimeout);
            this.notificationTimeout = null;
        }
    };
    RgLimitsPrompterComponent.prototype.startInterval = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = this.interval * 1000; }
        this.notificationTimeout = setTimeout(function () {
            _this.showNotification();
            _this.startInterval();
        }, timeout);
    };
    RgLimitsPrompterComponent.prototype.showNotification = function () {
        notificationService.show(this.$t('rg-limit-notification.text'), {
            closeDelay: NotificationDelay.LONG,
            uniqueID: 'rg-limit-notification-text',
        });
    };
    RgLimitsPrompterComponent.prototype.destroyed = function () {
        this.end();
    };
    __decorate([
        SessionChange({ immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], RgLimitsPrompterComponent.prototype, "sessionChange", null);
    RgLimitsPrompterComponent = __decorate([
        Component({
            name: 'rg-limits-prompter',
        })
    ], RgLimitsPrompterComponent);
    return RgLimitsPrompterComponent;
}(Mixins(MagicConfigMixin)));

export default RgLimitsPrompterComponent;
